import { render, staticRenderFns } from "./IvTherapiesProcedure.vue?vue&type=template&id=a29e0e00"
import script from "./IvTherapiesProcedure.vue?vue&type=script&lang=js"
export * from "./IvTherapiesProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports